import { type ConsentPreferences } from "./consent";

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
    fbq?: (...args: any[]) => void;
  }
}

const GTM_ID =
  (import.meta as ImportMeta & { env: Record<string, string> }).env?.VITE_GTM_ID ||
  "GTM-5PRQ6HXM";
const META_PIXEL_ID = (import.meta as ImportMeta & { env: Record<string, string> }).env
  ?.VITE_META_PIXEL_ID;

let gtmLoaded = false;
let marketingLoaded = false;

function loadGTM(): void {
  if (gtmLoaded || document.querySelector('script[src*="googletagmanager.com/gtm.js"]')) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.insertBefore(script, document.head.firstChild);

  if (!document.getElementById("gtm-noscript")) {
    const noscript = document.createElement("noscript");
    noscript.id = "gtm-noscript";
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.insertBefore(noscript, document.body.firstChild);
  }

  gtmLoaded = true;
}

function loadMetaPixel(): void {
  if (!META_PIXEL_ID || marketingLoaded) return;

  window.fbq = function fbq(...args: any[]) {
    (window.fbq as any).queue = (window.fbq as any).queue || [];
    (window.fbq as any).queue.push(args);
  };
  window.fbq("init", META_PIXEL_ID);
  window.fbq("track", "PageView");
  marketingLoaded = true;
}

export function applyConsentPreferences(preferences: ConsentPreferences): void {
  if (preferences.analytics) {
    loadGTM();
  }
  if (preferences.marketing) {
    loadMetaPixel();
  }
}

export function initAnalyticsFromConsent(): void {
  const stored = localStorage.getItem("parberkon_cookie_consent");
  if (!stored) return;

  try {
    const parsed = JSON.parse(stored);
    if (parsed?.preferences) {
      applyConsentPreferences(parsed.preferences);
    }
  } catch {
    // ignore malformed consent
  }
}

export function trackEvent(name: string, params?: Record<string, unknown>): void {
  if (gtmLoaded) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
  }

  if (META_PIXEL_ID && window.fbq && marketingLoaded) {
    window.fbq("trackCustom", name, params);
  }
}
